import { useEffect, useState } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import logoUrl from '/images/application_logo/docrevolution.png?url';

import { getEnv } from './config/Env';

export const ErrorFallback = ({ error }: FallbackProps) => {
    const { t } = useTranslation();
    const [showDetails, setShowDetails] = useState(false);

    const supportEmail = getEnv('SUPPORT_EMAIL', 'support@docrevolution.nl');
    const supportPhone = getEnv('SUPPORT_EMAIL', '+31 (0)85 400 51 51');

    useEffect(() => {
        const loader = document.getElementById('app-loader');

        if (loader) {
            loader.remove();
        }
    }, []);

    return (
        <div className="uk-width-1-1 uk-height-viewport">
            <div className="container" style={{ maxWidth: 640 }}>
                <div className="row">
                    <div className="col">
                        <div className="my-5 p-5 bg-white shadow-sm rounded-lg text-center">
                            <div className="d-inline-block mb-5" style={{ width: 200, marginRight: -90 }}>
                                <img src={logoUrl} alt="" />
                            </div>

                            <h3 className="font-weight-normal mb-3">{t('global:errorFallBack.title')}</h3>

                            <div className="mb-4">
                                {t('global:errorFallBack.subtitle', {
                                    supportEmail,
                                    supportPhone,
                                })}
                            </div>

                            <button onClick={() => (window.location.href = '/')} className="btn btn-primary">
                                {t('global:errorFallBack.backToApp')}
                            </button>

                            <div className="pt-4">
                                <button
                                    onClick={() => setShowDetails(!showDetails)}
                                    className="btn btn-outline-primary btn-sm"
                                >
                                    {showDetails
                                        ? t('global:errorFallBack.hideDetails')
                                        : t('global:errorFallBack.showDetails')}
                                </button>

                                {showDetails && (
                                    <div className="mt-4 mx-n3 text-left pt-4 text-xs overflow-auto font-mono">
                                        <pre className="mb-0">
                                            {error instanceof Error ? error.stack : String(error)}
                                        </pre>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
